<template>
  <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" app :value="drawer" @input="$emit('input', $event)">
    <v-list nav>
      <!--  Searching for orders -->
      <v-list-item :to="{ name: 'search' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.search</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.search') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--  Order control -->
      <v-list-item :to="{ name: 'check' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.ballotCheck</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.check') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--  Packing orders -->
      <v-list-item :to="{ name: 'packages' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.packages') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
